var _rect, _rect2, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNum1Icon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 96,
    height: 96,
    rx: 48,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 96,
    height: 96,
    rx: 48,
    stroke: "red",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "0.5 4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.225 28.6h17.422V72h-8.308V35.916h-9.114V28.6z",
    stroke: "red",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeDasharray: "0.5 4"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8cmVjdCB4PSIyIiB5PSIyIiB3aWR0aD0iOTYiIGhlaWdodD0iOTYiIHJ4PSI0OCIgZmlsbD0id2hpdGUiLz4NCjxyZWN0IHg9IjIiIHk9IjIiIHdpZHRoPSI5NiIgaGVpZ2h0PSI5NiIgcng9IjQ4IiBzdHJva2U9IiNGRjAwMDAiIHN0cm9rZS13aWR0aD0iMi41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0iYmV2ZWwiIHN0cm9rZS1kYXNoYXJyYXk9IjAuNSA0Ii8+DQo8cGF0aCBkPSJNMzguMjI0NiAyOC42SDU1LjY0NjZWNzJINDcuMzM4NlYzNS45MTZIMzguMjI0NlYyOC42WiIgc3Ryb2tlPSIjRkYwMDAwIiBzdHJva2Utd2lkdGg9IjIuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49ImJldmVsIiBzdHJva2UtZGFzaGFycmF5PSIwLjUgNCIvPg0KPC9zdmc+DQo=";
export { SvgNum1Icon as ReactComponent };